import { render } from "./SpareParts.vue?vue&type=template&id=1a7cdb92"
import script from "./SpareParts.vue?vue&type=script&lang=js"
export * from "./SpareParts.vue?vue&type=script&lang=js"

import "./SpareParts.vue?vue&type=style&index=0&id=1a7cdb92&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__